import { useFeatureFlagConfig } from 'ggx-global/hooks/use-feature-flag'

export default {
  useCustomTpTips() {
    return useFeatureFlagConfig('custom_tp_tips')
  },
}
